import { CircularProgress, Typography } from "@mui/material";
import json5 from "json5";
import lodash from "lodash";
import { useContext, useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import MUIButton from "../../Component/UI/MUIButton/MUIButton";
import MUIMultiSelect from "../../Component/UI/MUIMultiSelect/MUIMultiSelect";
import RadioGroup from "../../Component/UI/RadioGroup/RadioGroup";
import Warning from "../../Component/Warning/Warning";
import { fetchGpt4API } from "../../services/apiService";
import { LLM_OPTIONS } from "../../utils/constant";
import { validateBrandInput, validateProductInput,validateBrandInputValue,validateProductInputValue } from "../../utils/helpers";
import Suggestions from "../CategoryDiscovery/Suggestions/Suggestions";
import TextInput from "./../../Component/UI/TextInput/TextInput";
import classes from "./Form.module.css";
import { DiscoveryContext } from "./discovery-context";
import useGeneratePreCategoryDimensions from "./useGeneratePreCategoryDimensions";
import useGenerateProductTaxonomies from "./useGenerateProductTaxonomies";
import useTopUserProducts from "./useTopUserProducts";
import MUIMultiTextInput from "../../Component/UI/MUIMultiTextInput/MUIMultiTextInput";
import { Checkbox, FormControlLabel } from "@mui/material";
import useHistory from "./History/useHistory";
import Modal from "../../Component/Modal/Modal";

const RADIO_OPTIONS = [
  {
    value: "brand",
    label: "Brand",
  },
  {
    value: "product",
    label: "Product",
  },
];

export default function Form({
  onSubmit,
  onTypeChanged = () => { },
  onReset = () => { },
  warningText,
  setWarningText = () => { },
  cancelTransaction,
  stopPolling = () => { },
  setCancelTransaction = () => { },
}) {
  const discoveryCtx = useContext(DiscoveryContext);
  const [loading, setLoading] = useState(false);
  const [updatedKeyPlayers, setUpdatedKeyPlayers] = useState({});

  const [brand, setBrand] = useState("");
  const [domain, setDomain] = useState("");
  const [discoveryType, setDiscoveryType] = useState("brand");
  const [llm, setLLM] = useState(["gpt-4o"]);
  const [primaryLLM, setPrimaryLLM] = useState("gpt-4o");
  const [category, setCategory] = useState([]);
  // const [market, setMarket] = useState("");
  const [market, setMarket] = useState(["General Market"]);
  const [selectedBrandsProducts, setSelectedBrandProducts] = useState({});
  const [aICategories, setAICategories] = useState([]);
  const [isMock, setIsMock] = useState(false);
  const [isCategorySuggestionLoading, setCategorySuggestionLoading] =
    useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const categoryChangeTimerRef = useRef();
  const {
    loading: keyPlayersLoading,
    keyPlayers,
    setKeyPlayers,
    getBrandOrProductSuggestions,
  } = useTopUserProducts();
  const {
    deleteHistory,
  } = useHistory(discoveryType);
  const { generateProductTaxonomies, custom_taxonomies } = useGenerateProductTaxonomies();
  const { generatePreCategoryDimensions } = useGeneratePreCategoryDimensions();
  const abortControllerRef = useRef(null);

  const timerRef = useRef();

  useEffect(() => {
    if (!category || discoveryCtx.state.id) return;
    if (categoryChangeTimerRef.current) {
      clearTimeout(categoryChangeTimerRef.current);
    }
    category.forEach((currentCategory) => {
      if (!custom_taxonomies[currentCategory]) {
        categoryChangeTimerRef.current = setTimeout(() => {
          if (discoveryCtx.type === "category" || discoveryCtx.type === "product") {
            generateProductTaxonomies(currentCategory);
          }
          // generatePreCategoryDimensions(category);
        }, 1000);
      }
    })
    discoveryCtx.updateProductPrefs([]);

  }, [category, llm, brand]);

  useEffect(() => {
    if (!brand || discoveryCtx.is_launched) {
      setAICategories([]);
      return;
    }
    async function getCategoryAISuggestions() {
      setCategorySuggestionLoading(true);
      try {
        const prompt = `For the brand or product name '${brand}', list the **top 5 brand product categories** describing its market segment, primary use, or type. **Rules:** - Use only broad functional or market classifications. - Exclude model names, series names, version numbers, and product lines. - Categories must be widely recognized without brand knowledge. - Focus on role, form factor, target market, or core features. **Output (strict):** {\"categories\": [\"Category1\", \"Category2\", \"Category3\", \"Category4\", \"Category5\"]} No explanations or extra text.`
        let result = await fetchGpt4API(
          prompt,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          "Discovery"
        );
        result = result["GPT-4"][0];

        if (result) {
          let resultArray = json5.parse(result);
          setAICategories(
            resultArray.categories.map((o) => ({ name: o, value: o }))
          );
        }
      } catch (error) {
        console.log(error);
      } finally {
        setCategorySuggestionLoading(false);
      }
    }

    const debouncedFunction = lodash.debounce(getCategoryAISuggestions, 2000);
    debouncedFunction();
    return () => debouncedFunction.cancel();
  }, [brand, discoveryCtx.is_launched]);

  function handleProductBrandSelection(players, category) {
    console.log("player ", players);
    let categoryName = category;
    let maxProductBrands = 3;
    let message = "Only 3 competitors are allowed";

    setSelectedBrandProducts((prevPlayers) => {
      let competitor = { ...discoveryCtx.competitors };
      if (!competitor[categoryName]) {
        competitor[categoryName] = [];
      }
      let prevPlayersUpdated = { ...prevPlayers };
      let updatedPlayers = players.map((player) => {
        return {
          value: player,
          name: player,
          domain:
            competitor[categoryName].find((item) => item.name === player)
              ?.domain || "example.com",
        };
      });
      if (updatedPlayers.length > maxProductBrands) {
        toast.warn(message);
        updatedPlayers = updatedPlayers.slice(0, maxProductBrands);
        discoveryCtx.updatedCompetitors({ ...prevPlayersUpdated });
        return prevPlayers;
      } else {
        prevPlayersUpdated[categoryName] = updatedPlayers;
        competitor[categoryName] = updatedPlayers;
        discoveryCtx.updatedCompetitors({ ...prevPlayersUpdated });
        return prevPlayersUpdated;
      }
    });
  }

  function handleDeleteBrandProduct(itemName, categoryName) {
    setSelectedBrandProducts((prevBrandProducts) => {
      console.log("prevBrandProducts", prevBrandProducts, categoryName);
      prevBrandProducts[categoryName] = [
        ...prevBrandProducts[categoryName],
      ].filter((item) => item.name != itemName);
      return prevBrandProducts;
    });

    console.log("updatedCompetitors", discoveryCtx.competitors);
    let updatedCompetitors = [...discoveryCtx.competitors[categoryName]];
    console.log(
      "updatedCompetitors",
      discoveryCtx.competitors,
      "categoryName",
      categoryName,
      "itemName",
      itemName
    );
    updatedCompetitors = updatedCompetitors.filter(
      (comp) =>
        comp.name.toString().toLowerCase() !== itemName.toString().toLowerCase()
    );

    discoveryCtx.updatedCompetitors({
      ...discoveryCtx.competitors,
      [categoryName]: updatedCompetitors,
    });
  }

  // useEffect(() => {
  //  if (discoveryCtx.abort_launch || !discoveryCtx.is_launched) {
  //    setSelectedBrandProducts({});
  //  }
  // }, [discoveryCtx.abort_launch, discoveryCtx.is_launched]);

  // async function checkIfInputOrProductValid(input, isProduct = false) {
  //   setLoading(true);
  //   setWarningText("");
  //   try {
  //     const validateFn = isProduct ? validateProductInput : validateBrandInput;
  //     let response = await validateFn(input, category);
  //     setLoading(false);

  //     let variants = [];
  //     if (isProduct) {
  //       variants = (response?.data?.variants || []).map((variant) => ({
  //         id: variant,
  //         name: variant,
  //         active: true,
  //       }));
  //     }

  //     const isValid = response.data.ans === "Yes";
  //     const domain = response.data.domain || "example.com";

  //     setDomain(domain);

  //     if (!isValid) {
  //       if (
  //         !isProduct ||
  //         response?.data?.correct_inputs?.[0]?.toLowerCase().trim() !==
  //         discoveryCtx.entity?.toLowerCase().trim()
  //       ) {
  //         setWarningText(
  //           `The ${discoveryType} or category name appears to be incorrect. This may impact the Brand Index report.`
  //         );
  //       }
  //     }
  //   } catch (error) {
  //     console.log("Error while validating input", error);
  //     setLoading(false);
  //   }
  // }

  async function checkIfInputOrProductValid(input, isProduct = false) {
  setLoading(true);
  setWarningText("");

  // Cancel any previous request
  if (abortControllerRef.current) {
    abortControllerRef.current.abort();
  }
  const controller = new AbortController();
  abortControllerRef.current = controller;

  try {
    const validateFn = isProduct ? validateProductInputValue : validateBrandInputValue;
    let response = await validateFn(input, category, controller.signal);

    // Only continue if this request wasn’t aborted
    if (controller.signal.aborted) return;

    setLoading(false);

    const domain = response.data.data.domain || "example.com";
    console.log("checkIfInputOrProductValid", input, domain,response);

    setDomain(domain);

    const isValid = response.data.ans === "Yes";
    if (!isValid) {
      setWarningText(
        `The ${discoveryType} or category name appears to be incorrect. This may impact the Brand Index report.`
      );
    }
  } catch (error) {
    if (error.name !== "AbortError") {
      console.log("Error while validating input", error);
      setLoading(false);
    }
  }
}

  const debouncedValidation = useRef(
  lodash.debounce((value, type) => {
    checkIfInputOrProductValid(value, type === "product");
  }, 500)
).current;

  function handleBrandInputChange(e) {
    // Debounce the validation call for 300ms
    const value = e.target.value;
    // if (timerRef.current) {
    //   clearTimeout(timerRef.current);
    // }
    // timerRef.current = setTimeout(() => {
    //   checkIfInputOrProductValid(value, discoveryType === "product");
    // }, 500);
    setBrand(e.target.value);
    resetState();
    setCategory([]);
    setKeyPlayers([]);
    setSelectedBrandProducts({});
    setUpdatedKeyPlayers({});
    debouncedValidation(value, discoveryType);
  }

  function resetState() {
    discoveryCtx.updateAbortLaunch(true);
    discoveryCtx.updateId(null);
    discoveryCtx.updatedLaunched(false);
    // discoveryCtx.resetState();
  }

  function handleDiscoveryTypeChange(value) {
    discoveryCtx.resetState();
    onTypeChanged(value);
    discoveryCtx.updateType(value);
    setDiscoveryType(value);
    setBrand("");
    setCategory([]);
    setLLM(["gpt-4o"]);
    setKeyPlayers([]);
    setSelectedBrandProducts({});
    onReset();
    setMarket(["General Market"]);
  }
  useEffect(() => {
    if (!llm.includes(primaryLLM) && !discoveryCtx.state.id) {
      const next = llm[0] || "";
      setPrimaryLLM(next);
      discoveryCtx.updatePrimaryLLM(next);
    }
  }, [llm]);

  useEffect(() => {
    if (discoveryCtx.state.id) {
      setBrand(discoveryCtx.entity);
      setAICategories([
        {
          name: discoveryCtx.category,
          value: discoveryCtx.category,
        },
      ]);
      setCategory(discoveryCtx.category);
      setMarket(discoveryCtx.markets);
      setLLM(discoveryCtx.llm);
      //setSelectedBrandProducts(discoveryCtx.competitors);
    }
  }, [
    discoveryCtx.state.id,
    discoveryCtx.category,
    discoveryCtx.llm,
    discoveryCtx.entity,
    discoveryCtx.markets,
    discoveryCtx.competitors,
  ]);

  useEffect(() => {
    if (cancelTransaction && !discoveryCtx.abort_launch) {
      setBrand(discoveryCtx.entity);
      setCategory(discoveryCtx.category);
      setMarket(["General Market"]);
      setLLM(discoveryCtx.llm);
      setCancelTransaction(false);
    }
  }, [cancelTransaction, discoveryCtx.abort_launch])

  const cancelTransactionRecord = () => {
    stopPolling();
    setCancelTransaction(true);
    discoveryCtx.updateAbortLaunch(true);
  }



  const debounceLaunch = lodash.debounce(async function () {
    if ((!brand && discoveryType !== "category") || !category || !llm) {
      toast.warn("Please fill all required fields");
      return;
    }

    if (
      discoveryType === "category" &&
      (!discoveryCtx.location ||
        !discoveryCtx.occupation ||
        discoveryCtx.attributes.length === 0)
    ) {
      toast.warn("Please fill all required fields");
      return;
    }


    onSubmit({
      brand,
      category,
      market,
      llm,
      discoveryType,
      domain,
      isMock,
      primaryLLM
    });
  }, 1000);
  const hasRequiredCompetitors =
    Object.keys(discoveryCtx.competitors).length > 0 && Object.keys(discoveryCtx.competitors).every(
      (categoryName) => {
        const competitors = discoveryCtx.competitors[categoryName] || [];
        return competitors.length === 3 || categoryName === 'default';
      }
    );

  const hasRequiredLLMs = llm && llm.length >= 1;


  const renderAllCompetitors = () => {
    console.log("categoryData", category)
    return category.map((record) => {
      return renderCompetitors(record);
    });
  };

  const renderCompetitors = (categoryName) => {
    let options = updatedKeyPlayers[categoryName]
      ? updatedKeyPlayers[categoryName]
      : [];
    console.log("selectedBrandsProducts=", selectedBrandsProducts, keyPlayers);
    return (
      <div style={{ flex: 1.5 }}>
        <div className="d-flex flex-column">
          <MUIMultiSelect
            loading={keyPlayersLoading}
            disabled={discoveryCtx.status?.loading || discoveryCtx.is_launched}
            fullWidth={true}
            allowCustomOption={true}
            optionValue={""}
            label={`${categoryName} Competitors `}
            value={
              selectedBrandsProducts[categoryName]?.map((obj) => obj.name) || []
            }
            shouldShowValue={false}
            options={options}
            allowSettingPrimary={false}
            onChange={(e) => {
              handleProductBrandSelection(e, categoryName);
            }}
          />
          {discoveryCtx.competitors.length <= 3 && (
            <Typography
              color="textDisabled"
              variant="caption"
              sx={{ fontSize: "8px" }}
            >
              Select{" "}
              {discoveryType === "category" ? "key players " : "competitors "}
              <Typography
                color="error"
                variant="caption"
                sx={{ fontSize: "8px" }}
              >
                ({discoveryType === "category" ? `upto 4` : `Exactly 3`})
              </Typography>
            </Typography>
          )}
          {selectedBrandsProducts[categoryName] &&
            selectedBrandsProducts[categoryName].length > 0 && (
              <Suggestions
                options={selectedBrandsProducts[categoryName]}
                onDelete={(item) =>
                  handleDeleteBrandProduct(item, categoryName)
                }
                discoveryCtx={discoveryCtx}
              />
            )}
        </div>
      </div>
    );
  };


  useEffect(() => {
    let updatedKeyPlayersObj = { ...updatedKeyPlayers };
    console.log('key players', keyPlayers, 'SelectedBrandProducts', selectedBrandsProducts)
    Object.keys(keyPlayers).map((category) => {
      updatedKeyPlayersObj[category] = keyPlayers[category].map((player) => ({
        ...player,
        value: player.name,
        name: player.name,
      })
      )
    })
    setUpdatedKeyPlayers(updatedKeyPlayersObj);
    let updatedSelectedBrandsProducts = { ...selectedBrandsProducts };
    category.forEach((categoryName) => {
      if (
        selectedBrandsProducts[categoryName] &&
        selectedBrandsProducts[categoryName].length > 0
      ) {
        // If the category already has selected brands/products, do not update
      } else if (
        keyPlayers[categoryName] &&
        keyPlayers[categoryName].length > 0
      ) {
        updatedSelectedBrandsProducts[categoryName] =
          keyPlayers[categoryName].slice(0, 3) || [];
      }
    });
    setSelectedBrandProducts(updatedSelectedBrandsProducts);
    discoveryCtx.updatedCompetitors(updatedSelectedBrandsProducts);
  }, [keyPlayers]);

  function handleDeleteMarket(marketToDelete) {
    const updatedMarket = market.filter((marketName) => marketName !== marketToDelete);
    setMarket(updatedMarket);
  }

  const handlePrimaryLLMChange = (value) => {
    console.log('primary', value);
    discoveryCtx.updatePrimaryLLM(value);
    setPrimaryLLM(value);
  };

  function deleteTransaction() {
    discoveryCtx.resetState();
    deleteHistory(discoveryCtx?.state?.id);
    stopPolling();
    setShowDeleteDialog(false);
    setBrand("");
    setCategory([]);
    setLLM(["gpt-4o"]);
    setKeyPlayers([]);
    setSelectedBrandProducts({});
    onReset();
    setMarket(["General Market"]);
  }


  const updateCompetitorsByCategories = (categories) => {
    let newCompetitors = {};
    console.log("updateCompetitorsByCategories", categories, updatedKeyPlayers);
    categories.map((category) => {
      if (
        !updatedKeyPlayers[category] ||
        (updatedKeyPlayers[category] &&
          updatedKeyPlayers[category].length === 0)
      ) {
        newCompetitors[category] = [];
        console.log("callig getBrandOrProductSuggestions ", category);
        let type = discoveryCtx.type === "product" ? "product" : "brand";
        getBrandOrProductSuggestions(
          type,
          category,
          null,
          [],
          null,
          market,
          brand
        );
      } else {
        newCompetitors[category] = updatedKeyPlayers[category];
      }
    });
    setUpdatedKeyPlayers(newCompetitors);
  };
  console.log("primary 11", discoveryCtx.primary_llm, "llm", llm);
  return (
    <>
      <div className={classes.form}>
        <div className={classes.header}>
          <div className={classes.radio}>
            <RadioGroup
              disabled={discoveryCtx.status?.loading}
              className={classes.type_radio}
              options={RADIO_OPTIONS}
              onChange={handleDiscoveryTypeChange}
            />
          </div>
          {warningText && <Warning text={warningText} />}
        </div>

        <div className={classes.input_group}>
          <div className={classes.input_section}>
            <div className={classes.brand_input}>
              <TextInput
                disabled={discoveryCtx.status?.loading}
                fullWidth
                value={brand}
                label={discoveryType === "brand" ? "Brand" : "Product"}
                placeholder={
                  discoveryType === "brand" ? "Nike" : "Nike Air Force 1"
                }
                onChange={handleBrandInputChange}
              />
              {loading && (
                <CircularProgress className={classes.loading} size={15} />
              )}
            </div>

            {/* <div style={{ flex: 1 }}>
            <TextInput
              fullWidth
              label="Market"
              disabled={discoveryCtx.status?.loading}
              placeholder="e.g North America"
              value={market}
              onChange={(e) => {
                setMarket(e.target.value);
                // resetState();
              }}
            />
          </div> */}
            <div className={classes.market_input}>
              <MUIMultiTextInput value={market} onChange={setMarket} label={"Market"} onDelete={handleDeleteMarket} triggerWarning={() => setWarningText("Max 3 markets allowed!")} discoveryCtx={discoveryCtx} />
            </div>
            <div style={{ display: "flex", alignItems: "start" }}>
              <MUIMultiSelect
                disabled={discoveryCtx.status?.loading}
                label={"LLM*"}
                allowSettingPrimary={true}
                options={!discoveryCtx.is_launched ? LLM_OPTIONS : []}
                // value={discoveryCtx.llm || ["gpt-4o"]}
                value={(discoveryCtx.llm || ["gpt-4o"]).map((item) =>
                  item
                )}
                renderSelectedValues={(selected) => {
                  return selected
                    .map(val => LLM_OPTIONS.find(opt => opt.value === val)?.name || val)
                    .join(", ");
                }}
                onRadioChange={handlePrimaryLLMChange}
                selectedPrimary={discoveryCtx.primary_llm || "gpt-4o"}
                onChange={(selected, primary) => {
                  if (selected && selected.length > 4) {
                    toast.warn("Only 4 LLM selections are allowed")
                    setLLM([...llm]);
                    discoveryCtx.updateLLM([...discoveryCtx.llm]);
                    return
                  } else {
                    setLLM(selected);
                    discoveryCtx.updateLLM(selected);
                    setPrimaryLLM(primary)
                    discoveryCtx.updatePrimaryLLM(primary);
                  }
                }}
              />
            </div>
          </div>
          <div className={classes.input_section}>
            <MUIMultiSelect
              loading={isCategorySuggestionLoading}
              disabled={discoveryCtx.status?.loading || discoveryCtx.is_launched}
              allowSettingPrimary={false}
              source={brand}
              fullWidth
              placeholder="eg Athletic Apparel"
              label="Category"
              allowCustomOption={true}
              sx={{
                color: category ? "black" : "#979797",
              }}
              options={[...aICategories]}
              value={category}
              onChange={(selected) => {
                console.log("selected ==", selected);
                if (selected && selected.length > 3) {
                  let message = "Max 3 categories allowed";
                  setCategory([...category]);
                  updateCompetitorsByCategories([...category]);
                  toast.warn(message);
                  return;
                } else {
                  setCategory(selected);
                  updateCompetitorsByCategories(selected);
                }
              }}
            />
            {/* <div className="d-flex flex-column" style={{ flex: 1.6, display: "flex", marginTop: "1.5rem" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isMock}
                    onChange={(e) => setIsMock(e.target.checked)}
                    disabled={discoveryCtx.loading || discoveryCtx.is_launched}
                  />
                }
                label="isMock"
              />
            </div> */}
          </div>
          <div className={classes.input_section}>
            {renderAllCompetitors()}

            <div className="d-flex flex-column" style={{ flex: 0.7 }}>
              {!discoveryCtx?.state?.id && (
                <MUIButton
                  variant="contained"
                  color={discoveryCtx.status?.loading ? "error" : "primary"}
                  disabled={
                    loading ||
                    !category ||
                    discoveryCtx.is_launched ||
                    !market ||
                    !hasRequiredCompetitors ||
                    !hasRequiredLLMs
                  }
                  onClick={debounceLaunch}
                >
                  Launch
                </MUIButton>
              )}
              {discoveryCtx?.state?.id && (
                <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                  {discoveryCtx.state.transactionStatus !== "COMPLETED" && (
                    <MUIButton color="error" onClick={() => setShowDeleteDialog(true)}>
                      Cancel
                    </MUIButton>
                  )}
                  <MUIButton color="primary" onClick={cancelTransactionRecord}>
                    Start New
                  </MUIButton>
                </div>
              )}
            </div>
          </div>
        </div>

        <ToastContainer />
      </div>
      {discoveryCtx?.state?.id && (
        <Modal
          handleClose={() => setShowDeleteDialog(false)}
          handleConfirm={deleteTransaction}
          open={showDeleteDialog}
          title="Delete History?"
          showActions
          confirmBtnText="Delete"
          confirmBtnColor="error"
        >
          Do you want to delete this item - {discoveryCtx?.entity}?
        </Modal>
      )}
    </>
  );
}
